import { APP } from 'core-uda/model/Resource'
import LeftMenu from 'core-uda/ui/leftMenu/LeftMenu'
import { RIGHTS, DATA_AUTHORIZED } from 'core-uda/Rights'
import 'thm/ui/umv/ThmUmvLeftMenu.css'
import ResourceUI from 'core-uda/ui/ResourceUI'
import BeaconPage from 'core-mobile/ui/beacon/BeaconPage'

function isCentricAuthorized(buttonId) {
  return APP().getCurrentCentric().isLeftMenuAvailable(buttonId)
}

function openTabPage(module, context) {
  const pageClass = module.default,
    page = pageClass.get()

  page.setAutoClose(false)
  page.attr('tabFloat', true)

  pageClass.openPage(context)
}

/**
 * @class UmvLeftMenu
 */
let ThmUmvLeftMenu = LeftMenu.extend({
  id: 'umvLeftMenu',
  i18nPrefix: 'thm.ui.umv.ThmUmvLeftMenu.',

  // override
  init: function (config) {
    let me = this,
      radarMode = DATA_AUTHORIZED('radarProductOil')
        ? 'shipOilDetection'
        : 'shipDetection'

    me._super(config)

    APP().on('centricChanged', me.proxy(me.onCentricChanged))

    me.addButtons([
      {
        id: 'criteria',
        icon: 'positionSearch',
        handler: async function () {
          openTabPage(await import('thm/ui/umv/requestPage/ThmRequestPage'))
        },
        display: () => isCentricAuthorized('criteria'),
      },
      {
        id: 'sarCriteria',
        icon: 'positionSearch',
        handler: async function () {
          openTabPage(await import('core-sar/ui/sarRequest/SarRequestPage'))
        },
        display: () => isCentricAuthorized('sarCriteria'),
      },
      {
        id: 'rendering',
        icon: 'style',
        handler: async function () {
          openTabPage(await import('thm/ui/umv/ThmRenderingPage'))
        },
        display: () => isCentricAuthorized('rendering'),
      },
      {
        id: 'mobiles',
        icon: 'mobile',
        handler: function () {
          // TrajectoryPage.openPage();
          ResourceUI.openListSelectionPage('trajectories')
        },
        authorized: function () {
          return RIGHTS('mobile.trajectoriesTab')
        },
        display: () => isCentricAuthorized('mobiles'),
      },
      {
        id: 'zones',
        icon: 'zones',
        handler: function () {
          ResourceUI.openListSelectionPage('zones')
        },
        authorized: function () {
          return DATA_AUTHORIZED('zone')
        },
        display: () => isCentricAuthorized('zones'),
      },
      {
        id: 'commands',
        icon: 'command',
        handler: async function () {
          openTabPage(await import('core-mobile/ui/command/SendCommandPage'))
        },
        authorized: function () {
          return (
            DATA_AUTHORIZED('command') &&
            RIGHTS('data.command.create') &&
            RIGHTS('positions.sendCommandsActive')
          )
        },
      },
      {
        id: 'message',
        icon: 'mail',
        title: me.msg('message.title'),
        tooltipIcon: 0,
        handler: async function () {
          if (!APP().user.email) {
            const module = await import('core-cmp/msg/InformationPopup'),
              InformationPopup = module.default

            InformationPopup.openPage({
              titleKey: 'emailRequired',
              textKey: 'emailRequiredText',
              onClose: async function () {
                const module = await import(
                    'core-uda/ui/settings/UserInfosPage'
                  ),
                  UserInfosPage = module.default

                UserInfosPage.openPage()
              },
            })
            return
          } else {
            openTabPage(
              await import('thm/ui/common/message/MessageMobileListPage'),
            )
          }
        },
        authorized: function () {
          return DATA_AUTHORIZED('message', 'beaconModel')
        },
        display: () => isCentricAuthorized('message'),
      },
      {
        id: 'shipDetection',
        icon: 'vesselDetection',
        title: me.msg(radarMode + '.title'),
        label: me.msg(radarMode + '.label'),
        handler: function () {
          ResourceUI.openListSelectionPage('radarProduct')
        },
        authorized: function () {
          return DATA_AUTHORIZED('radarProduct')
        },
        display: () => isCentricAuthorized('shipDetection'),
      },
      {
        id: 'layers',
        icon: 'metoc',
        handler: async function () {
          openTabPage(await import('thm/ui/umv/multiLayer/ThmMultiLayerPage'), {
            model: APP().multiModel.models.metoc,
          })
        },
        authorized: function () {
          return RIGHTS('map.layers.metocAuthorized')
        },
        display: () => isCentricAuthorized('layers'),
      },
      {
        id: 'statistics',
        icon: 'chart',
        handler: async function () {
          openTabPage(await import('core-mobile/ui/statistic/StatisticPage'))
        },
        authorized: function () {
          return RIGHTS('umv.statistic')
        },
        display: () => isCentricAuthorized('statistics'),
      },
      {
        id: 'geoImages',
        icon: 'layers',
        handler: async function () {
          const module = await import('core-geotiff/ui/GeoTiffPage'),
            GeoTiffPage = module.default

          GeoTiffPage.openPage()
        },
        authorized: function () {
          return (
            RIGHTS('data.geoTiff.authorized') && RIGHTS('data.geoimages.accept')
          )
        },
        display: () => isCentricAuthorized('geoImages'),
      },
      {
        id: 'sar',
        icon: 'buoy',
        handler: async function () {
          openTabPage(await import('core-sar/ui/searchPage/SarPage'))
        },
        authorized: function () {
          return DATA_AUTHORIZED('sarOperations')
        },
        display: () => APP().getCurrentCentric().isLeftMenuAvailable('sar'),
      },
      {
        id: 'sarOil',
        icon: 'oil',
        handler: async function () {
          openTabPage(await import('core-sar-oil/ui/sarOilPage/SarOilPage'))
        },
        authorized: () => DATA_AUTHORIZED('searchAndRescueOil'),
        display: () => APP().getCurrentCentric().isLeftMenuAvailable('sarOil'),
      },
    ])
  },

  initViewModel: function () {
    let me = this
    me._super()

    me.viewModel.attr('metocModel', APP().metocModel)
    me.viewModel.attr('isCentricsHidden', !APP().isMultiCentrics())
    me.viewModel.attr('lockable', true)
  },
})

export default ThmUmvLeftMenu
